// Core
import React, { useState, useRef, useEffect, Suspense } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';

// Components
import StarsButton from '../../../components/Button/Button';

const TimerAndClaim = ({
	sessionTokens,
	setIsClaim,
	setPagePlay,
	setIsAccelerating,
	setTokens
}) => {
	const [timeLeft, setTimeLeft] = useState(3);
    const [secondTimer, setSecondTimer] = useState(30); 
    const [isClaimStep, setIsClaimStep] = useState(1);

	useEffect(() => {
      if (timeLeft > 0) {
          const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
          return () => clearTimeout(timer); // Очистка таймера
      } else {
          setIsAccelerating(true); // Через 3 секунды включаем ускорение
      }
	}, [timeLeft]);

	useEffect(() => {
	      if (timeLeft === 0 && secondTimer > 0) {
	          const timer = setTimeout(() => setSecondTimer(secondTimer - 1), 1000);
	          return () => clearTimeout(timer);
	      } else if (secondTimer === 0) {
	          setIsClaim(true);
	          setIsAccelerating(false); // Завершаем второй таймер
	      }
	}, [secondTimer, timeLeft]);


	const handleClaimTokens = () => {
		const setNewTokens = parseInt(localStorage.getItem('tokens') || 0, 10) + sessionTokens;
		localStorage.setItem('tokens', setNewTokens);

		const setNewAllTokens = parseInt(localStorage.getItem('allTokens') || 0, 10) + sessionTokens;
		localStorage.setItem('allTokens', setNewAllTokens);
		setIsClaimStep(2);
		setTokens(setNewTokens);
	};

	const history = useHistory();
	const handleExit = () => {
		setPagePlay(false);
		setIsClaim(false);
		setIsClaimStep(1);

		history.push('/');
	};

	const handleClaimAndNextTokens = () => {
		//setIsClaim(false);
		//setIsClaimStep(1);
		window.location.reload();
	};

	return (
	    <>      
			{ timeLeft > 0 ? (
				<Box zIndex="999" position="absolute" left="50%" transform="translate(-50%, 0px)" top="20%" textAling="center">
				  <Text fontSize="50px">{`00:0${timeLeft}`}</Text>
				</Box>  
				) : secondTimer > 0 ? (
				<Box zIndex="999" position="absolute" left="50%" transform="translate(-50%, 0px)" top="20%" w="200px" textAlign="center">
				  <Text fontSize="50px">{`00:${secondTimer < 10 ? `0${secondTimer}` : secondTimer}`}</Text>
				  <Box position="absolute" bottom="0px" h="2px" bg="red" w={`${Math.round((secondTimer / 30) * 100)}%`} />
				</Box> 
			) : (
				<>
				  { isClaimStep === 1 ? (
				    <Box zIndex="999" position="absolute" className="claim-btn" left="50%" transform="translate(-50%, 0px)" top="20%" textAling="center">
				      <Text fontSize="20px" textAling="center">Flight <span style={{ color: 'rgba(255, 187, 24, 1)'}}>completed</span></Text>
				      <Text fontSize="20px" textAling="center">Нou earned <span style={{ color: 'rgba(255, 187, 24, 1)'}}>{sessionTokens}</span></Text>
				      <StarsButton text="claim" pt="0px" mt="-30px" onClick={handleClaimTokens} />
				    </Box>
				  ) : (
				    <Box zIndex="999" position="absolute" className="claim-btn" left="50%" transform="translate(-50%, 0px)" top="20%" textAling="center">
				      <StarsButton text="Exit" pt="0px" mt="-30px" onClick={handleExit} />
				      <StarsButton text="Next" pt="0px" mt="-110px" onClick={handleClaimAndNextTokens} />
				    </Box>
				  )}
				</>
			)}
	    </>
    );
};

export default TimerAndClaim;